import { useTranslation } from 'react-i18next';
import { Organization } from '../../../models/PartnerServerData';
import { NS } from '../../../models/I18n';
import { ReactComponent as Logo } from '../assets/img/logo-white.svg';

interface CrsSectionProps {
  organization?: Organization;
  crsScore: number;
}

export function SuperVisasSideBar() {
  const { t } = useTranslation(NS.Shared);
  return (
    <>
      <div className="hidden w-full bg-brand-blue pb-6 text-center lg:block lg:min-h-screen lg:w-1/4 lg:px-6">
        <Logo className="mt-64 inline-block w-full" />
        <div className="mx-auto text-xl font-semibold text-white">{t('eligibilityResult.eligibility-check')}</div>
      </div>
      <div className="flex h-24 w-full items-center justify-center bg-brand-blue py-3 lg:hidden">
        <Logo className="inline-block w-32" />
        <div className="ml-4 border-l-2 border-solid border-white pl-4 text-lg font-semibold text-white">
          {t('eligibilityResult.eligibility-check')}
        </div>
      </div>
    </>
  );
}

function CrsSection({ organization, crsScore }: CrsSectionProps) {
  const { t } = useTranslation(NS.Shared);
  if (organization) {
    const { logo, name } = organization;
    return (
      <div className="w-full bg-brand-blue pb-6 pt-3 text-center lg:min-h-screen lg:w-1/4">
        <div className="flex items-center justify-center">
          <img className="max-w-[130px]" src={logo} alt={`${name}'s logo`} />
          <span className="border-left ml-3 border-solid border-white pl-3 text-xl font-bold text-white">
            {t('eligibilityResult.eligibility-check')}
          </span>
        </div>
        <div className="mt-6 lg:mt-36">
          <div className="text-xl font-bold text-white">{t('eligibilityResult.crs-score')}</div>
          <div className="text-4xl font-extrabold text-white lg:text-7xl">{crsScore}</div>
        </div>
      </div>
    );
  }
  return <SuperVisasSideBar />;
}

export default CrsSection;
